
function createTaskTag () {
  return {
    restrict: 'E',
    templateUrl: '/admin/dialogs/create-task-tag/create-task-tag.html?$$REVISION$$'
  }
}
export { createTaskTag }
